<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-file-document"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="12">
          <v-row class="mx-1">
            <v-col cols="12">
              <v-row class="ml-n5">
                <v-col cols="8">
                  <v-col cols="5">
                    <v-text-field
                        v-model="projects.name"
                        dense
                        label="Tên project"
                        outlined
                        @input="debounceInput"
                    ></v-text-field>
                  </v-col>

                </v-col>
                <v-col class="text-right" cols="4">
                  <v-btn
                      color="primary"
                      @click="addProject"
                  >
                    Thêm project
                  </v-btn>
                </v-col>

              </v-row>
            </v-col>
          </v-row>
          <v-row align="center" class="mt-n6" justify="center">
            <v-col cols="12">
              <v-data-table
                  :headers="headers"
                  :items="results"
                  :items-per-page="10"
                  class="elevation-1"
              >
                <template v-slot:item.photo_url="{ item }">
                  <img :alt="url + item.photo_url"
                       :src=" item.photo_url ? url+ item.photo_url : require('@/assets/images/logo_Eglife1.png')"
                       class="pt-2" width="100"/>
                </template>
                <template v-slot:item.active="{ item }">
                  <v-switch
                      v-model="item.active"
                      class="pa-3"
                      :value="item.active"
                      @click="updateActive(item.id)"
                  ></v-switch>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon class="mr-2" small @click="editItem(item.id)">
                    mdi-pencil
                  </v-icon>
                  <v-icon small @click="deleteItem(item.id)"> mdi-delete</v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>

      </v-row>

    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  DELETE_PROJECT, SEARCH_PROJECT, UPDATE_ACTIVE,
} from "@/store/modules/project";
import {debounce} from "debounce";

export default {
  name: "Project",
  data() {
    return {
      page: "Danh sách Projects",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách Projects",
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'STT',
          align: 'start',
          value: 'id',
        },
        {text: 'Ảnh cover', value: 'photo_url', sortable: false},
        {text: 'Tên', value: 'name'},
        {text: 'Mô tả', value: 'short_description', sortable: false},
        {text: 'Vị trí', value: 'order'},
        {text: 'Hiển thị ', value: 'active'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      url: '',
      selected: -1,
      projects: [{
        name: ""
      }],
    }
  },
  computed: {
    ...mapGetters({
      results:"results"
    }),
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(SEARCH_PROJECT);

  },
  methods: {
    debounceInput: debounce(function (e) {
      this.projects.name = e;
      let param = {name: this.projects.name};
      this.$store.dispatch(SEARCH_PROJECT, param);
    }, 200),

    addProject() {
      this.$router.push('/project_management/project/add_project')
    },
    editItem(id) {
      this.$router.push({
        path: "/project_management/project/edit_project/" + id,
      });
    },
    deleteItem(id) {
      confirm('Bạn có chắc chắn muốn xóa không ?') &&
      this.$store.dispatch(`${DELETE_PROJECT}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(SEARCH_PROJECT);
        }
      })
    },
    async updateActive(id) {
      this.results.forEach(item => {
        if (item.id == id) {
          this.selected = item.active == true ? 1 : 0
        }
      })
      let data = {
        id: id,
        active: this.selected
      }
      await this.$store.dispatch(`${UPDATE_ACTIVE}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/project_management/project')
        } else {
          alert(data.data.errors)
        }
      });
    }
  }
}
</script>

<style scoped>

</style>